import React, { useState, useEffect, useRef } from "react";
import { Form, Input, Button, Upload, Select, message, Modal } from "antd";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router-dom";
import { binaryContentsHooks as cHooks } from "../hooks";

const { Option } = Select;

const ShortsEditPage = () => {
  const [form] = Form.useForm();
  const [thumbnail, setThumbnail] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(""); // 이미지 URL 저장
  const [htmlContent, setHtmlContent] = useState("");
  const [groupList, setGroupList] = useState([]);
  const [authorList, setAuthorList] = useState([]);
  const [isImagePromptVisible, setIsImagePromptVisible] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
  const { contentData } = location.state || {}; // 전달된 콘텐츠 데이터
  const quillRef = useRef(null); // ReactQuill 인스턴스 참조

  // 그룹 리스트 불러오기
  // const fetchGroups = async () => {
  //   try {
  //     const res = await cHooks.contentsGroupList();
  //     if (res.data) setGroupList(res.data.data);
  //   } catch (error) {
  //     message.error("그룹 리스트 불러오기 실패!");
  //   }
  // };

  const authorGroups = async () => {
    try {
      const res = await cHooks.contentsAuthorList();
      if (res.data) setAuthorList(res.data.data);
    } catch (error) {
      message.error("작성자 리스트 불러오기 실패!");
    }
  };

  // HTML 파일의 body 내용만 추출
  const fetchHtmlContent = async (url) => {
    try {
      const response = await fetch(url, {
        method: "GET",
      });
      if (!response.ok) {
        throw new Error("HTML 파일을 가져오는 중 오류가 발생했습니다.");
      }
      const htmlString = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      setHtmlContent(doc.body.innerHTML); // 에디터에 설정
    } catch (error) {
      message.error("HTML 콘텐츠를 불러오는 데 실패했습니다.");
    }
  };
  console.log(contentData)
  useEffect(() => {
    // fetchGroups();
    authorGroups();
    if (contentData) {
      form.setFieldsValue({
        content_title: contentData.content_title,
        // content_group_id: contentData.content_group_id,
        // content_inner_tag: contentData.content_inner_tag,
        // content_tag: contentData.content_tag,
        content_video_link:contentData.content_video_link,
        content_summary: contentData.content_summary,
        author_id: contentData.author_id,
      });
      setThumbnail(contentData.content_thumbnail);
      setBackgroundImage(contentData.content_background_image);
      if (contentData.content_description) {
        fetchHtmlContent(contentData.content_description);
      }
    }
  }, [contentData]);

  // Base64 변환 핸들러
  const handleBase64Upload = (file, setter) => {
    const reader = new FileReader();
    reader.onload = (e) => setter(e.target.result);
    reader.readAsDataURL(file);
    return false;
  };

  // 이미지 업로드 후 URL 반환
  const handleImageUploadAndGetUrl = async (file) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      const base64Image = e.target.result.split(",")[1];
      try {
        const res = await cHooks.contentsImageUpload({ base64Image });
        if (res.data?.url) {
          setUploadedImageUrl(res.data.url);
          message.success("이미지 URL 반환 성공!");
        } else {
          throw new Error("URL 반환 실패");
        }
      } catch (error) {
        message.error("이미지 업로드 실패!");
      }
    };
    reader.readAsDataURL(file);
    return false;
  };

  // 이미지 URL 에디터 삽입
  const handleInsertImage = () => {
    if (uploadedImageUrl) {
      const quill = quillRef.current.getEditor();
      const currentPosition = quill.getSelection()?.index || quill.getLength();
      quill.insertEmbed(currentPosition, "image", uploadedImageUrl);
      setUploadedImageUrl("");
      setIsImagePromptVisible(false);
      message.success("이미지가 삽입되었습니다!");
    } else {
      message.error("유효한 이미지 URL이 없습니다!");
    }
  };

  // 폼 제출 처리
  const handleSubmit = async (values) => {
    try {
      const payload = {
        ...values,
        content_thumbnail: thumbnail.includes("base64")
          ? thumbnail.split(",")[1]
          : thumbnail,
        // content_background_image: backgroundImage.includes("base64")
        //   ? backgroundImage.split(",")[1]
        //   : backgroundImage,
        // content_description: btoa(unescape(encodeURIComponent(htmlContent))),
      };
      const res = await cHooks.contentsUpdate({
        id: contentData.id,
        contentTitle: payload.content_title,
        contentThumbnail: payload.content_thumbnail,
        contentType: "shorts",
        contentBinaryType: "url",
        contentVideoLink: payload.content_video_link,
        // contentGroupId: payload.content_group_id,
        // contentInnerTag: payload.content_inner_tag,
        // contentTag: payload.content_tag,
        contentSummary: payload.content_summary,
        authorId: payload.author_id,
      });
      if (res.IsError) {
        throw new Error();
      }
      message.success("콘텐츠가 성공적으로 수정되었습니다!");

      navigate(`/shorts?page=${location.state.page}`);
    } catch (error) {
      message.error("콘텐츠 수정 실패!");
    }
  };

  // 콘텐츠 삭제
  const handleDelete = async () => {
    try {
      const res = await cHooks.contentsDelete({ id: contentData.id });
      if (res.IsError) {
        throw new Error();
      }
      message.success("콘텐츠가 삭제되었습니다!");
      navigate("/shorts?page=${location.state.page}");
    } catch (error) {
      message.error("콘텐츠 삭제 실패!");
    }
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "20px" }}>
      <h2>콘텐츠 수정 페이지</h2>
      <Form layout="vertical" form={form} onFinish={handleSubmit}>
        <Form.Item
          name="content_title"
          label="제목"
          rules={[{ required: true, message: "제목을 입력해주세요" }]}
        >
          <Input.TextArea rows={2} />
        </Form.Item>

        {/* 작성자 설정 */}
        <Form.Item name="author_id" label="작성자 설정">
          <Select placeholder="작성자를 선택하세요">
            {authorList.map((group) => (
              <Option key={group.id} value={group.id}>
                {group.user_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {/* <Form.Item name="content_inner_tag" label="내부 태그">
          <Input placeholder="태그 입력 (예: 여성건강,수면)" />
        </Form.Item>
        <Form.Item name="content_tag" label="외부 태그">
          <Input placeholder="태그 입력 (예: 건강관리,수면질)" />
        </Form.Item>
        <Form.Item name="content_summary" label="컨텐츠 요약">
          <Input placeholder="컨텐츠 내용 요약" />
        </Form.Item> */}

        <Form.Item label="썸네일">
          <Upload
            beforeUpload={(file) => handleBase64Upload(file, setThumbnail)}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>썸네일 업로드</Button>
          </Upload>
          {thumbnail && (
            <img
              src={thumbnail}
              alt="썸네일"
              style={{ width: "150px", marginTop: "10px" }}
            />
          )}
        </Form.Item>

        {/* <Form.Item label="백그라운드 이미지">
          <Upload
            beforeUpload={(file) =>
              handleBase64Upload(file, setBackgroundImage)
            }
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>백그라운드 이미지 업로드</Button>
          </Upload>
          {backgroundImage && (
            <img
              src={backgroundImage}
              alt="배경 이미지"
              style={{ width: "150px", marginTop: "10px" }}
            />
          )}
        </Form.Item> */}

        {/* <Form.Item label="이미지 URL 반환 및 삽입">
          <Upload
            beforeUpload={handleImageUploadAndGetUrl}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>이미지 업로드</Button>
          </Upload>
          <Input
            placeholder="반환된 이미지 URL"
            value={uploadedImageUrl}
            onChange={(e) => setUploadedImageUrl(e.target.value)}
            style={{ marginTop: "10px" }}
          />
          <Button
            type="dashed"
            onClick={handleInsertImage}
            disabled={!uploadedImageUrl}
            style={{ marginTop: "10px" }}
          >
            에디터에 이미지 삽입
          </Button>
        </Form.Item> */}

        {/* <Form.Item label="내용">
          <ReactQuill
            ref={quillRef}
            theme="snow"
            value={htmlContent}
            onChange={setHtmlContent}
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, 4, 5, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ align: [] }],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link"],
                ["clean"],
              ],
            }}
            style={{ height: "300px", marginBottom: "50px", width: "360px" }}
          />
        </Form.Item> */}
        <Form.Item
          name="content_video_link"
          label="비디오 링크"
          rules={[{ required: true, message: "링크를 입력해주세요" }]}
        >
          <Input.TextArea rows={2} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            수정하기
          </Button>
          <Button danger style={{ marginLeft: "10px" }} onClick={handleDelete}>
            삭제하기
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ShortsEditPage;
